import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, TextField } from '@material-ui/core';
import { SettlementTypeEnumDto } from '.generated/api';

interface SettlementTypeSelectProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  required?: boolean;
}

const SettlementTypeSelect: React.FC<SettlementTypeSelectProps> = (props) => {
  const { t } = useTranslation(['translations']);

  return (
    <TextField
      variant="outlined"
      fullWidth
      select
      label={t('organization_page.contract.labels.settlement_type')}
      name="settlementType"
      {...props}
    >
      {Object.values(SettlementTypeEnumDto).map((settlementType) => (
        <MenuItem key={settlementType} value={settlementType}>
          {t(
            `organization_page.contract.settlement_type.${settlementType.toLowerCase()}`,
          )}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default SettlementTypeSelect;
